export default __webpack_public_path__ + "static/media/dashboard-logo.320f92f4.png";